import React from 'react';

import  './index.module.less';

import { INotificationRecordItem } from '@apis/notification/getNotificationRecordRemindItems';
import PageNavigator from '@helpers/PageNavigator';
import { Confirm } from '@components/ConfirmModal'

interface IProps {
  contentInfo: INotificationRecordItem;
  onClose: () => void;
  onConfirm: () => void;
}

const AuthModal = (props: IProps) => {
  const { contentInfo, onConfirm, onClose } = props;
  const content = contentInfo.body ? JSON.parse(contentInfo.body) : {};
  const action = contentInfo.action ? JSON.parse(contentInfo.action) : {};
  const texts = content.data1?.content
    ? content.data1?.content.split('。')
    : [];

  const reject = (cancelType: string) => {
    if(cancelType === 'cancel') {
      onClose && onClose();
    }
  };

  const agree = () => {
    onConfirm && onConfirm();
  };

  const toDetailPage = () => {
    const url = content.rich1.texts[1].hyperlink;
    PageNavigator.to({ url });
  };

  return (
    <Confirm
      title={contentInfo.title}
      onCancel={reject}
      onConfirm={agree}
      showCancelBtn
      cancelBtnText={action.action2.name}
      confirmBtnText={action.action1.name}
      ContentWidget={
        <>
         <div styleName="content">
          {texts.map((i: string) => (
            <div styleName="desc">{i}</div>
          ))}
        </div>
        <div styleName="tip">
          {content.rich1.texts[0]?.content}
          <span onClick={toDetailPage}>{content.rich1.texts[1]?.content}</span>
        </div>
        </>
      }
    />
  );
};

export default AuthModal;
